"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNavigateState = void 0;
// @ts-ignore
var Navigate_1 = require("ellipse/navigate/Navigate");
// @ts-ignore
var zustand_1 = require("zustand");
// @ts-ignore
var useNavigateStateInt = (0, zustand_1.create)(function (set) { return ({
    // @ts-ignore
    url: Navigate_1.Navigate.url(),
    // @ts-ignore
    setUrl: function (url) { return set({
        url: url
    }); },
}); });
// @ts-ignore
var useNavigateState = function () {
    // @ts-ignore
    var ns = useNavigateStateInt();
    // @ts-ignore
    if (Navigate_1.Navigate.onUpdate === undefined) {
        // @ts-ignore
        var setUrl_1 = ns.setUrl;
        // @ts-ignore
        Navigate_1.Navigate.onUpdate = function (url) {
            setUrl_1(url);
        };
    }
    return ns;
};
exports.useNavigateState = useNavigateState;
